/**
 * @file
 * Check if JavaScript is enabled functionality.
 */

(($, { behaviors }) => {
  /**
   * Attaches behavior for checking if JavaScript is enabled.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *  Attaches check if JavaScript is enabled functionality.
   */
  behaviors.isJavascriptEnabled = {
    attach(context) {
      $(".js-body", context).removeClass("no-js");
    }
  };
})(jQuery, Drupal);
